<template>
    <MainContainer>
        <div class="finanzkonto">
            <h2>
                Finanzkonten
                <b-button
                    v-if="checkRight('write')"
                    :size="size"
                    @click="dataCreate">
                    Neu
                    <font-awesome-icon icon="plus" />
                </b-button>
            </h2>
            <Table
                bordered
                striped
                small
                showFilter
                :fields="fields"
                :items="items"
                :isBusy="busy"
                sortBy="kontonr"
                busyText="Lädt Finanzkonten..."
                emptyText="Keine Finanzkonten gefunden"
            >
                <template v-slot:actions="{ row: row }">
                    <b-button
                        v-if="checkRight('write')"
                        :size="size"
                        variant="link"
                        @click="dataSelected(row)"
                        class="mv-table-action-btn mr-1"
                        >Bearbeiten</b-button
                    >
                    <b-button
                        v-if="checkRight('delete')"
                        :size="size"
                        @click="dataDelete(row)"
                        variant="link"
                        class="text-danger mv-table-action-btn"
                        >Löschen</b-button
                    >
                </template>
            </Table>
            <EditModal
                :title="selected.title"
                :busy="selected.busy"
                buttonText="Speichern"
                scrollable
                @ok="dataProvide"
                @hide="dataHide"
            >
                <template v-if="selected.data">
                    <FormGroupBuilder
                        :fields="ioFields"
                        :data="selected.data"
                        :refresh="validationRefresh"
                    />
                </template>
            </EditModal>
            <RemoveModal
                :title="selected.title"
                :busy="selected.busy"
                @ok="dataProvide"
                @hide="dataHide"
            />
        </div>
    </MainContainer>
</template>

<script>
import CommonView from "@/mixins/CommonView/CommonView";
import Size from "@/mixins/Size/Size";
import Validation from "@/mixins/Validation/Validation";
import { ApiFactory } from "@/api/ApiFactory.js";
import MainContainer from "@/components/MainContainer/MainContainer";
import Table from "@/components/Table/Table";
import EditModal from "@/components/EditModal/EditModal";
import RemoveModal from "@/components/RemoveModal/RemoveModal";
import FormGroupBuilder from "@/components/FormGroupBuilder/FormGroupBuilder";

const FiBuFinanzkontoApi = ApiFactory.get("fibuFinanzkonto");

export default {
    name: "FiBu_Finanzkonto",
    mixins: [CommonView, Size, Validation],
    components: {
        MainContainer,
        Table,
        EditModal,
        RemoveModal,
        FormGroupBuilder
    },
    data() {
        return {
            fields: [
                {
                    key: "id",
                    value: "ID",
                    sortable: true
                },
                {
                    key: "kontonr",
                    label: "Kontonummer",
                    sortable: true
                },
                {
                    key: "text",
                    label: "Beschreibung",
                    sortable: true
                },
                {
                    key: "praefix",
                    label: "Buchungs-Präfix"
                },
                {
                    key: "bnr",
                    label: "letzte Buchungsnummer",
                    class: "text-right"
                },
                {
                    key: "actions",
                    label: "Funktionen",
                    class: "text-center"
                }
            ],
            ioFields: [
                {
                    key: "id",
                    label: "ID",
                    type: "text",
                    disabled: true
                },
                {
                    key: "kontonr",
                    label: "Kontonummer",
                    type: "text",
                    mandatory: true
                },
                {
                    key: "text",
                    label: "Beschreibung",
                    type: "text",
                    mandatory: true
                },
                {
                    key: "praefix",
                    label: "Buchungs-Präfix",
                    type: "text",
                    mandatory: true
                },
                {
                    key: "bnr",
                    label: "letzte Buchungsnummer",
                    type: "text",
                    disabled: true
                }
            ],
            api: FiBuFinanzkontoApi
        };
    },
    watch: {},
    methods: {
        postProcessCreate(selectedItem, response) {
            selectedItem.id = response.json.id;
            return selectedItem;
        },
        fetchErrorHandling(response) {
            this.handleValidationData(response, this.ioFields);
        },
        postDataSet() {
            this.cleanValidationData(this.ioFields);
        }
    }
};
</script>
